const TrainerDatesDetail = () => import("./views/TrainerDatesDetail.vue");
const TrainerDatesOverview = () => import("./views/TrainerDatesOverview.vue");

export const trainerRoutes = [
  {
    path: "/trainer",
    name: "TrainerDatesOverview",
    component: TrainerDatesOverview,
    props: true,
  },
  {
    path: "/trainer/:dateId",
    name: "TrainerDatesDetail",
    component: TrainerDatesDetail,
    props: true,
  },
];
